export default "__VITE_ASSET__DrrE7XDR__"